import LawFirmHomeBase from "./components/LawFirmHomeBase";
import { LF_HOME_VARIANT } from "./lawFirmHomeConfig";

const LawFirmUserAdminHome = () => <LawFirmHomeBase variant={LF_HOME_VARIANT.admin} />;

export default LawFirmUserAdminHome;
